import { useState } from 'react';
import { Sparkle, ArrowClockwise } from '@phosphor-icons/react';
import { streamAI } from '../../lib/aiStream';
import { AiText } from './AiText';

export const AiInsightCard = ({ period, periodLabel }) => {
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const run = async () => {
    setLoading(true);
    setError('');
    setText('');
    try {
      await streamAI('/ai/insight', { period }, setText);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative overflow-hidden bg-card border border-primary/30 rounded-xl p-5 lg:p-6" data-testid="ai-insight-card">
      <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-gradient-to-br from-blue-500/15 to-emerald-400/20 blur-2xl pointer-events-none" />
      <div className="relative flex flex-wrap items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center"><Sparkle size={22} weight="duotone" className="text-primary" /></div>
          <div>
            <h2 className="font-display text-lg font-semibold">Analisis Bisnis AI</h2>
            <p className="text-xs text-muted-foreground">Claude membaca data {periodLabel.toLowerCase()} dan memberi saran</p>
          </div>
        </div>
        <button onClick={run} disabled={loading} data-testid="btn-ai-insight"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary text-primary-foreground text-sm font-medium hover:opacity-90 disabled:opacity-60 transition-opacity">
          {text ? <ArrowClockwise size={16} /> : <Sparkle size={16} weight="fill" />}
          {loading ? 'Menganalisis…' : text ? 'Analisis Ulang' : 'Analisis Sekarang'}
        </button>
      </div>
      <div className="relative mt-4">
        {error && <div className="text-sm text-rose-600" data-testid="ai-insight-error">{error}</div>}
        {!text && !error && !loading && (
          <p className="text-sm text-muted-foreground">Tekan tombol untuk ringkasan produk unggulan, biaya terbesar, stok/expired, dan 3 saran aksi.</p>
        )}
        {loading && !text && <div className="h-4 w-1/2 rounded bg-secondary animate-pulse" />}
        {text && <AiText text={text} testid="ai-insight-text" />}
      </div>
    </div>
  );
};
